import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { NumberInput } from "@/components/ui/number-input";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import type { QuickForm } from "./pricingGridUtils";
import { formatDayRange } from "./pricingGridUtils";

interface PricingQuickCreateProps {
  quickForm: QuickForm;
  onUpdate: (form: QuickForm) => void;
  onSave: () => void;
  onCancel: () => void;
}

export default function PricingQuickCreatePopover({
  quickForm,
  onUpdate,
  onSave,
  onCancel,
}: PricingQuickCreateProps) {
  return (
    <div className="fixed inset-0 z-40" onClick={onCancel}>
      <div
        className="absolute z-50 bg-popover border rounded-lg shadow-lg p-4 w-72 animate-in fade-in-0 zoom-in-95"
        style={{
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <p className="text-sm font-medium mb-3">
          Skapa prisregel: {formatDayRange(quickForm.days)}, {quickForm.startTime}–{quickForm.endTime}
        </p>
        <div className="space-y-3">
          <div>
            <Label className="text-xs">Namn</Label>
            <Input
              placeholder="T.ex. Peak vardagar"
              value={quickForm.name}
              onChange={(e) => onUpdate({ ...quickForm, name: e.target.value })}
              className="h-8 text-sm"
              autoFocus
            />
          </div>
          <div>
            <Label className="text-xs">Pris (kr/h)</Label>
            <NumberInput
              placeholder="0"
              value={quickForm.price ?? ""}
              onValueChange={(v) => onUpdate({ ...quickForm, price: v || 0 })}
              className="h-8 text-sm"
            />
          </div>
          <div className="flex items-center gap-2">
            <Switch
              checked={quickForm.isPeak}
              onCheckedChange={(v) => onUpdate({ ...quickForm, isPeak: v })}
            />
            <Label className="text-xs">Peak-tid</Label>
          </div>
          <div className="flex gap-2">
            <Button size="sm" className="flex-1" onClick={onSave} disabled={quickForm.price == null}>
              Spara
            </Button>
            <Button size="sm" variant="ghost" onClick={onCancel}>
              Avbryt
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
